import React from 'react';
import ReactDOM from 'react-dom';
import Root from 'Root'
import App from 'App';
import * as serviceWorker from './serviceWorker';

import './styles.css'
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/slide.css';
import 'react-s-alert/dist/s-alert-css-effects/scale.css';

ReactDOM.render(
    <Root>
        <App />
    </Root>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();